import { Component } from "@angular/core";
import { environment } from "src/environments/environment";

@Component({
    selector: "ow-header",
    templateUrl: "./header.component.html"
})
export class HeaderComponent {

    public readonly title = environment.customerType === "business" ? "Glasfaseranschluss bestellen - Business" : "Glasfaseranschluss bestellen"
}
